import type { ReactNode } from 'react';
import React, { Fragment, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useSnowplowService } from '../../../../../../../shared/application/hooks/useSnowplow';

interface TrackPageViewProps {
  children: ReactNode;
}

export const TrackPageView = ({ children }: TrackPageViewProps) => {
  const { sendPageView } = useSnowplowService();
  const { pathname, search } = useLocation();

  useEffect(() => {
    sendPageView();
  }, [search, pathname, sendPageView]);

  return <Fragment>{children}</Fragment>;
};
